import { IConfigurationModel } from "@nf/common";

import { HeaderLogo } from "components";
import AppImage from "components/AppImage";
import AppFooterDesktop from "components/AppFooter/AppFooterDesktop";
import LandingPageCard from "components/Configuration/CustomComponents/LandingPageCard";

import styles from "./NotAvailableScreen.module.scss";

export type NotAvailableComponent = {
  backgroundImageUrl?: string;
  title?: string;
  availability: {
    message?: string;
    label?: string;
    countries?: Array<{
      name?: string;
      redirectUrl?: string;
    }>;
  };
};

export interface NotAvailableScreenProps {
  component: NotAvailableComponent;
  configuration?: IConfigurationModel;
}

const NotAvailableScreen = ({
  component,
  configuration,
}: NotAvailableScreenProps) => {
  const availability = component.availability;
  const countries = availability?.countries;

  return (
    <div className={styles.container}>
      {component.backgroundImageUrl && (
        <AppImage
          alt=""
          fill={true}
          isLCP={true}
          src={component.backgroundImageUrl}
          className={styles.background}
        />
      )}

      <div className={styles.gradient} />

      <div className={styles.content}>
        <div className={styles.top}>
          <HeaderLogo className={styles.logo} />

          <p className={styles.subtitle}>{component.title}</p>
        </div>

        <LandingPageCard>
          <h1 className={styles.message}>{availability.message}</h1>

          <h2 className={styles.label}>{availability.label}</h2>

          <div className={styles.countries}>
            {countries?.map((country) => (
              <a
                key={country.redirectUrl}
                href={country.redirectUrl}
                className={styles.country}
              >
                {country.name}
              </a>
            ))}
          </div>
        </LandingPageCard>
      </div>

      <div className={styles.footer}>
        <AppFooterDesktop configuration={configuration} />
      </div>
    </div>
  );
};

export default NotAvailableScreen;
